/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Image, Text } from '@components/atoms'
import { Footer } from '@components/systems'
import aboutUsImage from '@public/images/pages/about/aboutUs.jpg'

import { grey } from '@mui/material/colors'

const AboutPage = () => {
	return (
		<View css={style}>
			<View className="outerView">
				<View className="contentOuterView">
					<View className="contentTitleView">
						<Text category="h1">ABOUT US</Text>
					</View>
					<View className="contentView">
						<View className="bgView">
							<Image src={aboutUsImage} className="bgImage" />
						</View>
						<View className="contentTitleView">
							<Text className="contentTitle">We’re a group of pedal</Text>
							<Text className="contentTitle">makers in Busan,</Text>
							<Text className="contentTitle">South Korea.</Text>
						</View>
						<View className="contentTextView">
							<View className="contentTextInnerView">
								<Text className="content">
									Our first pedal, Warped Kedem 6, was an analog vibrato with a digital
									brain. The idea was to match the quality and character of analog
									processing with the anything-goes flexibility of digital control. We
									make digital circuits now too, but the approach is the same: Offer new
									and deeply personal ways to interact with effects.
								</Text>
							</View>
						</View>
					</View>
				</View>
			</View>

			<Footer />
		</View>
	)
}

export default AboutPage

const style = css({
	position: 'relative',
	width: '100%',

	'.outerView': {
		display: 'flex',
		paddingTop: '2rem',
		paddingBottom: '2rem',
		borderBottom: '1px solid',
		borderColor: grey[300],

		'.contentOuterView': {
			width: '100%',

			'.contentTitleView': {
				paddingLeft: '2rem',
				paddingRight: '2rem',
			},

			'.contentView': {
				position: 'relative',
				borderTop: '1px solid',
				borderColor: grey[500],

				'.bgView': {
					position: 'relative',
					width: '100%',
					height: '60rem',
					overflow: 'hidden',

					'.bgImage': {
						position: 'absolute',
						top: 0,
						left: 0,
						width: '100%',
						height: 'auto',
					},
				},

				'.contentTitleView': {
					'.contentTitle': {
						fontSize: '100px',
						lineHeight: '20px',
					},
				},

				'.contentTextView': {
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					width: '100%',
					paddingBottom: '5rem',

					'.contentTextInnerView': {
						width: '80%',

						'.content': {
							fontSize: '30px',
							fontWeight: '100',
							lineHeight: '50px',
						},
					},
				},
			},
		},
	},
})
